<div class="side-menu-desktop-root">
  <div class="epson-logo-size-setter">
    <app-epson-logo animateOnHover></app-epson-logo>
  </div>
  <div class="menu-items">
    <ng-container *ngFor="let nav of flatNavItems">
      <app-sidemenu-item
        id="{{ 'lnr-sidemenuitem-' + nav[0].replace('-', '') }}"
        (click)="onRoute(nav[0])"
        icon="{{ nav[1] }}"
        [isMobile]="false"
        [isActive]="'/' + nav[0] == activeNavRoute"
        [itemName]="nav[2]"
      >
      </app-sidemenu-item>
    </ng-container>
  </div>
  <app-epson-powered></app-epson-powered>
</div>
